module.exports = __webpack_public_path__ + "a458d0f57031c68fda82a687f0e67948.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/survey1.png
// module id = 723
// module chunks = 0